import Strategy from "app/types/Strategy";
// Actions
import MixpanelActions from "app/features/mixpanel/MixpanelActions";
// Strategies
import {
  handleCalendarEpisodePageLinkOpenStrategy,
  handleCalendarEpisodePagePreviewOpenStrategy
} from "app/features/mixpanel/MixpanelStrategies/Calendar.strategies";

const CalendarStrategyMap:Record<string, Strategy> = {
  [MixpanelActions.handleCalendarEpisodePageLinkOpen.type]: handleCalendarEpisodePageLinkOpenStrategy,
  [MixpanelActions.handleCalendarEpisodePagePreviewOpen.type]: handleCalendarEpisodePagePreviewOpenStrategy,
};

export default CalendarStrategyMap;